import { ImageWithPlaceholder } from '@/common/components/ImageWithPlaceholder'
import { FailedConsumptionData } from '@/common/types/client/failedConsumption.type'
import { formatCurrency, formatDateTime, formatUnit } from '@/common/utils/formatters'
import { transformToNumber } from '@/common/utils/transformers'
import { EstablishmentFailedConsumptionDetails } from '@/features/establishments/components/EstablishmentFailedConsumptionDetails'
import { EstablishmentFailedConsumptionTableItem } from '@/features/establishments/types/establishmentFailedConsumption.type'
import { UserRoundIcon } from 'lucide-react'
import React from 'react'

export class EstablishmentFailedConsumptionsTransformer {
  static tableTransformer(): (events: FailedConsumptionData[]) => EstablishmentFailedConsumptionTableItem[] {
    return (events) => {
      return events.map((event) => {
        const totalAmount = transformToNumber({ value: event.total_amount })

        return {
          protocol_number: event.protocol_number,
          eventable_type: eventableTypeTranslations['Client::Consumption'],
          details: React.createElement(EstablishmentFailedConsumptionDetails, { data: event }),
          total_amount: Number.isNaN(totalAmount) ? '--' : formatCurrency(totalAmount),
          card: event.card?.last_four_digits ? event.card.last_four_digits.padStart(8, '*') : '--',
          usage_declaration: event.current_equipment_usage
            ? formatUnit(event.current_equipment_usage, event.current_equipment_usage_unit)
            : '--',
          license_plate: event.card?.equipment_field_for_display_value || '',
          capture_method: event?.capture_method?.display_name || '--',
          created_at: formatDateTime(new Date(event.created_at)),
          buyer: (
            <div className="flex items-center gap-[10px]">
              <ImageWithPlaceholder
                url={event.buyer?.profile_picture?.url}
                alt={event.buyer?.full_name}
                className="size-6"
                iconClassName="size-4"
                placeholderIcon={UserRoundIcon}
              />
              <p>{event.buyer?.full_name}</p>
            </div>
          ),
        }
      })
    }
  }
}

const eventableTypeTranslations: { [key: string]: string } = {
  'Client::Consumption': 'Consumo',
  'Billing::Refund': 'Estorno',
}
